export default __webpack_public_path__ + "static/media/dashboard_breadcrumb.285386c4.svg";